module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_iter-step.js
// module id = 217
// module chunks = 1